// Product type extension (API catalog store/extensions/product-type): the Type tab — what the product is, a type
// of the product-type tree, and what that makes it: the content type that decides how it is sold and shown
// (a book page with the player, an album page, a store page; shipped, a download, a key). The content type is
// never picked by hand: the type decides it (book {productTypeSet} writes both).
import { CubeIcon } from "@heroicons/react/24/outline"
import TypeTab from "./TypeTab"
import { CatalogEditorProvider, catalogSection, useCatalogVisibilityContext } from "../shared/catalog-editor"
import { reviewBadge } from "../shared/review-marks"

export const StoreProductExtension = {
  // every catalog product is of a type: the content type's list of extensions does not scope this tab
  allProducts: true,
  id: "product-type",
  label: "Type",
  description: "What the product is: its type, which decides how it is sold and shown",
  section: {
    component: catalogSection(TypeTab),
    label: "Type",
    icon: CubeIcon,
    // what a reviewer marked here for the vendor (shared/review-marks)
    badge: reviewBadge("product-type"),
    order: 105,
    visible: (context) => !!context?.catalogProduct,
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
